/**
 * 列表页 OSS 缩略图整页预签（查询后一次批量请求）。最后更新：2026-07-01
 */
import { prefetchTableOssMedia } from '../utils/mediaUrl'

export default {
  methods: {
    /**
     * 列表数据加载后批量预签 OSS 缩略图（每查询 1～N 次批量请求，每批最多 80 条）
     * @param {Array} rows 列表行数据（尚未赋值给表格也可）
     * @param {string|string[]|Function} pickMediaField 字段名、字段名数组或 (row)=>值
     */
    prefetchListOssMedia(rows, pickMediaField) {
      return prefetchTableOssMedia(this, rows, pickMediaField, { inline: true }).catch((e) => {
        console.warn('[prefetchListOssMedia]', e)
      })
    },
  },
}
